import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

const ShortCodeRedirect = () => {
  const { code } = useParams<{ code: string }>();
  const location = useLocation();

  useEffect(() => {
    if (!code) {
      window.location.replace('/');
      return;
    }

    // Country codes for matching: AT, ES, DE, FR, UK, etc.
    // Pattern: 2-letter country code followed by 6 alphanumeric characters
    // Add new country codes to this array as needed
    const countryCodes = [
      'AT',
      'ES',
      'DE',
      'FR',
      'UK',
      'IT',
      'NL',
      'BE',
      'LU',
      'CH',
      'PL',
      'CZ',
      'SK',
      'HU',
      'RO',
      'BG',
      'GR',
      'HR',
      'SI',
      'EE',
      'LV',
      'LT',
      'FI',
      'SE',
      'NO',
      'DK',
      'IS',
      'IE',
      'GB',
      'PT',
    ];
    const countryCodePattern = countryCodes.join('|');
    const regex = new RegExp(`^(${countryCodePattern})[A-Z0-9]{6}$`);

    if (regex.test(code)) {
      const isDevelopment = import.meta.env.DEV;
      const baseUrl = isDevelopment ? 'http://localhost:8090/access' : 'https://app2.verdea.app/access';

      // Preserve query parameters if any
      const searchParams = location.search;
      const redirectUrl = `${baseUrl}/${code}${searchParams}`;

      if (isDevelopment) {
        console.log(`Short code redirect: ${code} -> ${redirectUrl}`);
      }

      window.location.replace(redirectUrl);
    } else {
      // Not a valid short code, redirect to homepage
      if (import.meta.env.DEV) {
        console.log(`Invalid short code format: ${code}`);
      }
      window.location.replace('/');
    }
  }, [code, location.search]);

  // Simple loading spinner
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <div
        style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ShortCodeRedirect;
